<div *ngIf="popupMenuItem.enabled; then activeBlock; else disabledBlock"></div>
<ng-template #activeBlock>
    <hr *ngIf="popupMenuItem.separator" />
    <div *ngIf="!!popupMenuItem.link; then linkBlock; else ctaBlock"></div>
    <ng-template #linkBlock>
        <div *ngIf="popupMenuItem.isHrefLink"
             class="popup-menu-item {{typePopup}}"
             [ngClass]="popupMenuItem.klass"
             title="{{ text }}">
            <i class="fa-fw {{popupMenuItem.icon}}"
               [ngClass]="popupMenuItem.klass"
               aria-hidden="true"></i>
            <a [href]="popupMenuItem.link" target="_blank">
                <span class="text">{{ text }}</span>
            </a>
        </div>
        <div *ngIf="!popupMenuItem.isHrefLink"
             class="popup-menu-item {{typePopup}}"
             [ngClass]="popupMenuItem.klass"
             routerLink="{{ popupMenuItem.link }}"
             routerLinkActive="active"
             title="{{ text }}"
             (click)="linkClick()">
            <i class="fa-fw {{popupMenuItem.icon}}"
               [ngClass]="popupMenuItem.klass"
               aria-hidden="true"></i>
            <span class="text">{{ text }}</span>
        </div>
    </ng-template>
    <ng-template #ctaBlock>
        <div class="popup-menu-item {{typePopup}}"
             [ngClass]="popupMenuItem.klass"
             title="{{ text }}"
             (click)="ctaClick($event)">
            <i class="fa-fw {{popupMenuItem.icon}}"
               [ngClass]="popupMenuItem.klass"
               aria-hidden="true"></i>
            <span class="text">{{ text }}</span>
        </div>
    </ng-template>
</ng-template>
<ng-template #disabledBlock>
    <hr *ngIf="popupMenuItem.separator" />
    <div class="popup-menu-item disabled {{typePopup}}">
        <i class="fa-fw"
           [ngClass]="popupMenuItem.icon"
           aria-hidden="true"></i>
        <span class="text">{{ text }}</span>
    </div>
</ng-template>
